// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumb--2vPFr"};